import { useState, useCallback } from "react";

export type DialogType =
  | "history"
  | "referenceTimePicker"
  | "testData"
  | "createFile"
  | "assignCode"
  | "logs"
  | "addJob"
  | "deleteJob"
  | null;

export const useJobRunnerDialogs = () => {
  const [openDialog, setOpenDialog] = useState<DialogType>(null);

  const openHistoryDialog = useCallback(() => setOpenDialog("history"), []);
  const openReferenceTimePickerDialog = useCallback(
    () => setOpenDialog("referenceTimePicker"),
    []
  );
  const openTestDataDialog = useCallback(() => setOpenDialog("testData"), []);
  const openCreateFileDialog = useCallback(
    () => setOpenDialog("createFile"),
    []
  );
  const openAssignCodeDialog = useCallback(
    () => setOpenDialog("assignCode"),
    []
  );
  const openLogsDialog = useCallback(() => setOpenDialog("logs"), []);
  const openAddJobDialog = useCallback(() => setOpenDialog("addJob"), []);
  const openDeleteJobDialog = useCallback(
    () => setOpenDialog("deleteJob"),
    []
  );
  const closeDialog = useCallback(() => setOpenDialog(null), []);

  return {
    openDialog,
    setOpenDialog,
    closeDialog,
    openHistoryDialog,
    openReferenceTimePickerDialog,
    openTestDataDialog,
    openCreateFileDialog,
    openAssignCodeDialog,
    openLogsDialog,
    openAddJobDialog,
    openDeleteJobDialog,
  };
};
